import { _ftCamField } from './campaign-field';
import { ftClockCalendarFromArr, type CampaignClockCols } from './campaign-clock';

export type CampaignSunMode = 'night' | 'sunrise' | 'day' | 'sunset';
export const LIGHT_BY_SUN = { day: '0CC8A592-CF4C-7BE4-DD0C-17A41D690A05', sunrise: '61D1498F-9175-6906-4B26-8356C28B28C1',
    sunset: '61D1498F-9175-6906-4B26-8356C28B28C1', night: '99D3E371-AC3F-7839-28E7-770FE50D24C1' };
export const SUN_IDS = { day: '7650DB9F-465F-DDA6-9D7E-E064F4BC910F', sunrise: '04494E0F-FD0B-B2E7-3E15-94922127ADA2',
    sunset: '7BA5009E-B362-AE2F-ABB6-D06D54D306EA', night: 'E4B7F803-C689-A9A5-0FB7-EB8D9946874E' };
const SEASONS: Record<string, [number, number, number, number]> = {
    '8D31485E-8590-7829-2918-2BEA0F1C125C': [390, 420, 1140, 1170],
    'C3A3E1D8-1393-370F-C3D5-FEA77B0EB518': [330, 360, 1200, 1230],
    '69DDD63C-1DEF-A3C2-DF5C-D022747821CA': [420, 450, 1080, 1110],
    '467B3256-C3F2-3426-217D-A8A779ED62FB': [450, 480, 990, 1020],
};
export function sunModeForClock(minutes: number, transitions: readonly [number, number, number, number]): CampaignSunMode {
    const [riseDim, rise, setDim, set] = transitions;
    return minutes >= riseDim && minutes < rise ? 'sunrise' : minutes >= rise && minutes < setDim ? 'day'
        : minutes >= setDim && minutes < set ? 'sunset' : 'night';
}
export function campaignLightForClock(campaign: Record<string, unknown>, clock: CampaignClockCols) {
    const mode = (_ftCamField(campaign, 'campaign_light_cycle_mode') ?? '').toUpperCase();
    const endless: Record<string, CampaignSunMode> = { '472EBA96-F2BE-A721-E01E-8FF9EBA8C4BB': 'night',
        '383B5324-0F9C-5C00-F24B-EB740839B91A': 'sunset', 'D82E7DC2-F7E0-B92A-BDBE-DC241D01F353': 'day' };
    let sun = endless[mode];
    let transitions: [number, number, number, number] | null = null;
    if (!sun) {
        const season = ftClockCalendarFromArr(campaign).months.find(m => m.month_order === clock.month)?.month_season;
        const base = SEASONS[String(season ?? '').toUpperCase()] ?? SEASONS['C3A3E1D8-1393-370F-C3D5-FEA77B0EB518']!;
        const shift = mode === 'B0BB8478-C762-B215-32C0-0F668187BB8F' ? -120 : mode === 'C5DC831D-788C-982C-FFAB-7B97949E3979' ? 120 : 0;
        const clamp = (n: number): number => Math.max(0, Math.min(1439, n));
        transitions = [clamp(base[0] + shift), clamp(base[1] + shift), clamp(base[2] - shift), clamp(base[3] - shift)];
        for (let i = 1; i < 4; i++) transitions[i] = Math.min(1439, Math.max(transitions[i]!, transitions[i - 1]! + 1));
        sun = sunModeForClock(clock.hour * 60 + clock.minute, transitions);
    }
    const messages = { sunrise: 'the_sun_begins_to_rise', day: 'the_sun_has_risen', sunset: 'the_sun_begins_to_set', night: 'the_sun_has_set' };
    return { campaign_light: LIGHT_BY_SUN[sun], campaign_sun_state: SUN_IDS[sun], transitions, message: endless[mode] ? null : messages[sun] };
}
